/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// https://github.com/maxmarinich/react-alice-carousel
// https://openbase.com/js/react-alice-carousel/documentation#optionsfoverl
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

// styles and images0
import Spinner from '../buttons/Spinner';
import plusImg from '../../assets/icons/plus.svg';
import minusImg from '../../assets/icons/minus.svg';
import spinImg from '../../assets/icons/spin.webp';
import styles from './Main.module.css';

// components
import Canvas from '../canvas/Canvas';

import Select from '../buttons/Select';
import ImgBtn from '../buttons/ImgBtn';
import Input from '../buttons/NumberInput';
import StepSlider from '../buttons/StepSlider';

// code
import ExampleHeader from '../main/ExampleHeader';
import data, { uiData } from '../../logic/data';

import calcFunctions from '../../logic/calc';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  state = {
    busyCount: 0,
    loaded: 0, // number of images loaded

    exampleIdx: data.exampleIdx,
    groupIdx: data.groupIdx,

    maxOpacity: data.examples[data.groupIdx][data.exampleIdx].maxOpacity,
    step: data.examples[data.groupIdx][data.exampleIdx].step,
    opacity:
      data.examples[0][data.exampleIdx].topOpacity ||
      data.examples[0][data.exampleIdx].maxOpacity,

    busy: false,

    // data2D: [calcFunctions.clearData2D(), calcFunctions.clearData2D()],
    data2D: [null, null],

    // topImgIdx: 0,
    // bottomImgIdx: 0,
    topImage: data.topImages[data.topImageIdx],
    bottomImage: data.bottomImages[data.bottomImageIdx],

    topImageIdx: data.topImageIdx,
    bottomImageIdx: data.bottomImageIdx,

    bottomSlideNumber: uiData.bottomSlideNumber,
    topSlideNumber: uiData.topSlideNumber,

    matrix: null,
  };

  TOP_IDX = 1;
  BOTTOM_IDX = 0;

  botRef = React.createRef();
  topRef = React.createRef();

  slide2Val(bot = data.bottomImageIdx, top = data.topImageIdx) {
    this.botRef.current.slideTo(bot);
    this.topRef.current.slideTo(top);
    this.setState({ bottomImageIdx: bot, topImageIdx: top });
  }

  onSlideNumberChange = (idx, val) => {
    if (idx === this.TOP_IDX) {
      this.slide2Val(this.state.bottomImageIdx, val);
    } else {
      this.slide2Val(val, this.state.topImageIdx);
    }
  };

  handleGroupChange = val => {
    // console.log('[EXAMPLE]', val);
    this.setState({ groupIdx: val });
    this.handleExampleChange(data.exampleIdx, val);
    // this.slide2Val();
  };
  handleExampleChange = (val, groupIdx = this.state.groupIdx) => {
    // console.log({val, groupIdx})
    // opacity: data.examples[0][0].maxOpacity,
    if (groupIdx <= 1) {
      const topOpacity = data.examples[0][val].topOpacity;
      if (topOpacity !== undefined) {
        this.setState({ opacity: topOpacity });
      } else {
        this.setState({ opacity: data.examples[0][val].maxOpacity });
      }
    } else {
      this.setState({ opacity: data.examples[0][val].maxOpacity });
    }

    this.props.onExampleChange(groupIdx, val);
    this.setState({ exampleIdx: val, busy: false });
  };

  // alice carousel
  initSlider = () => {
    // console.log(this.state.busyCount, this.state.loaded);
    this.setState(prev => ({ busyCount: prev.busyCount + 1 }));
    this.slide2Val();
  };

  handleSlideChangedBottom = e => {
    this.setState(prev => {
      let data2D = [...prev.data2D];
      data2D[this.BOTTOM_IDX] = null;
      return {
        bottomImageIdx: e.item,
        bottomImage: data.bottomImages[e.item],
        data2D,
        bottomSlideNumber: { ...prev.bottomSlideNumber, value: e.item + 1 },
      };
    });
  };
  handleSlideChangedTop = e => {
    this.setState(prev => {
      let data2D = [...prev.data2D];
      data2D[this.TOP_IDX] = null;
      return {
        topImageIdx: e.item,
        topImage: data.topImages[e.item],
        data2D,
        topSlideNumber: { ...prev.topSlideNumber, value: e.item + 1 },
      };
    });
  };
  itemsBottom = data.bottomImages.map(el => (
    <img src={el} className={styles.sliderImg} alt='random' />
  ));
  itemsTop = data.topImages.map(el => (
    <img src={el} className={styles.sliderImg} alt='random' />
  ));

  // slider change
  handleStepSliderChange = val => {
    this.setState({ opacity: val });
  };

  topOpacityInGroup1 = opacity => {
    const topOpacity = data.examples[0][this.state.exampleIdx].topOpacity;
    if (topOpacity !== undefined) {
      opacity = topOpacity;
    }

    return opacity;
  };

  handleMinusClick = () => {
    let opacity = this.state.opacity;
    if (opacity > 0) {
      opacity -= this.state.step;
    }
    opacity = this.topOpacityInGroup1(opacity);
    this.handleStepSliderChange(opacity);
  };

  handlePlusClick = () => {
    let opacity = this.state.opacity;
    if (opacity < this.state.maxOpacity) {
      opacity += this.state.step;
    }
    opacity = this.topOpacityInGroup1(opacity);
    this.handleStepSliderChange(opacity);
  };

  handleImgLoad = (dataDraw, width, height, idx) => {
    // console.log(dataDraw)
    // if top and bottom are not processed yet
    // console.log(this.state.busyCount, this.state.loaded);

    // console.log({ dataDraw });
    this.setState(state => {
      const data2D = state.data2D;
      if (data2D[idx] === null) {
        data2D[idx] = calcFunctions.data2DrawConvert2Data2D(
          dataDraw,
          width,
          height,
        );

        return {
          data2D: data2D,
          loaded: state.loaded + 1,
        };
      }
    });
  };

  handleImgLoadTop = (dataDraw, width, height) => {
    this.handleImgLoad(dataDraw, width, height, this.TOP_IDX);
  };
  handleImgLoadBottom = (dataDraw, width, height) => {
    this.handleImgLoad(dataDraw, width, height, this.BOTTOM_IDX);
  };

  // blending on parameters update
  componentDidUpdate(prevProps, prevState) {
    const { busyCount, loaded, opacity, data2D, groupIdx, exampleIdx } =
      this.state;
    if (busyCount === 2 && loaded >= 2) {
      // console.log(data2D);

      if (
        prevState.loaded !== loaded ||
        prevState.opacity !== opacity ||
        prevState.exampleIdx !== exampleIdx ||
        prevState.groupIdx !== groupIdx
      ) {
        setTimeout(
          calcFunctions.blend.bind(this, opacity, data2D, groupIdx, exampleIdx),
          0,
        );
      }
    }
  }

  // HTML code
  render() {
    const { busyCount, loaded } = this.state;
    // console.log(loaded)
    let topImageBg = 'transparent';
    let topImageBtnShow = 'none';
    if (this.state.groupIdx <= 1) {
      const op = this.state.opacity;
      topImageBg = `rgba(${255 * op}, ${255 * op}, ${255 * op}, 1)`;
      topImageBtnShow = 'block';
    }

    return (
      <main className={styles.main} id='main' name='main'>
        {this.state.busy && (
          <img src={spinImg} alt='spinner image' className={styles.busy} />
        )}
        {/* {(busyCount < 2 || loaded <= 2) && <Spinner />} */}
        {(busyCount < 2 || loaded < 2) && <Spinner />}

        <div className={styles.slidesHeading}>
          {/* selection */}
          <div className={styles.inputs}>
            <Select
              options={uiData.groupOptions}
              selectedIdx={this.state.groupIdx}
              onSelectChange={this.handleGroupChange}
            />
            <Select
              options={uiData.selectOptions[this.state.groupIdx]}
              selectedIdx={this.state.exampleIdx}
              onSelectChange={this.handleExampleChange}
            />
          </div>

          <ExampleHeader
            groupIdx={this.state.groupIdx}
            exampleIdx={this.state.exampleIdx}
          />

          {/* sliders */}
          <div className={styles.carousels}>
            <div className={styles.layer}>
              <span>שכבה עליונה B </span>
              <div className={styles.topSlider}>
                <AliceCarousel
                  ref={this.topRef}
                  onInitialized={this.initSlider}
                  keyboardNavigation
                  mouseTracking
                  items={this.itemsTop}
                  onSlideChanged={this.handleSlideChangedTop}
                  // style={{ opacity:  }}
                />
                <div
                  className={styles.sliderImgOverlay}
                  style={{ backgroundColor: topImageBg }}
                ></div>
                <div
                  className={styles.btnOverlay}
                  style={{ display: topImageBtnShow }}
                ></div>
              </div>
              <div
                className={styles.slideNumbers}
                style={{ display: this.state.groupIdx <= 1 ? 'none' : 'flex' }}
              >
                {data.topImages.length} /
                <Input
                  obj={this.state.topSlideNumber}
                  onChange={val =>
                    this.onSlideNumberChange(this.TOP_IDX, val - 1)
                  }
                />
              </div>
            </div>
            <div className={styles.layer}>
              <span>שכבה  A </span>
              <AliceCarousel
                ref={this.botRef}
                onInitialized={this.initSlider}
                keyboardNavigation
                items={this.itemsBottom}
                onSlideChanged={this.handleSlideChangedBottom}
              />

              <div className={styles.slideNumbers}>
                {data.bottomImages.length} /
                <Input
                  obj={this.state.bottomSlideNumber}
                  onChange={val =>
                    this.onSlideNumberChange(this.BOTTOM_IDX, val - 1)
                  }
                />
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div className={styles.result}>
          <hr></hr>
          <p className={styles.resultHeading}>תוצאה C</p>

          <div className={styles.frames}>
            <Canvas
              title=''
              size={data.size}
              matrix={null}
              image={true}
              src={this.state.bottomImage}
              onImgLoad={this.handleImgLoadBottom}
              className='source'
            />
            <Canvas
              title=''
              size={data.size}
              matrix={null}
              image={true}
              src={this.state.topImage}
              onImgLoad={this.handleImgLoadTop}
              className='source'
            />
            <Canvas
              title=''
              size={data.size}
              matrix={this.state.matrix}
              image={false}
              // src={null}
              // onImgLoad={this.handleImgLoad}
            />
          </div>

          {/* inputs */}
          <div className={styles.slider}>
            <ImgBtn src={plusImg} onClick={this.handlePlusClick} small={true} />
            <StepSlider
              title='x'
              onChange={this.handleStepSliderChange}
              marks
              min={0}
              max={this.state.maxOpacity}
              step={this.state.step}
              value={this.topOpacityInGroup1(this.state.opacity)}
              valueLabelDisplay='on'
            />
            <ImgBtn
              src={minusImg}
              onClick={this.handleMinusClick}
              small={true}
            />
          </div>
          <div className={styles.mobileInputs + ' ' + styles.inputs}>
            <Select
              options={uiData.groupOptions}
              selectedIdx={this.state.groupIdx}
              onSelectChange={this.handleGroupChange}
            />
            <Select
              options={uiData.selectOptions[this.state.groupIdx]}
              selectedIdx={this.state.exampleIdx}
              onSelectChange={this.handleExampleChange}
            />
          </div>
          <hr></hr>
        </div>
      </main>
    );
  }
}

export default Main;
